const init = () => {
  const sliders = document.querySelectorAll('.swiper--custom-cursor');

  if (!sliders.length) return;

  const cursor = document.createElement('div');
  cursor.className = 'custom-cursor';
  cursor.innerHTML = `
    <div class="cursor-arrow cursor-arrow--left">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_8620_2987)">
          <path d="M13.332 18.75L4.58203 10L13.332 1.25" stroke="#35382E" stroke-width="1.66667"/>
        </g>
        <defs>
          <clipPath id="clip0_8620_2987">
              <rect width="20" height="20" fill="white" transform="translate(20 20) rotate(-180)"/>
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="cursor-arrow cursor-arrow--right">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66797 1.25L15.418 10L6.66797 18.75" stroke="#35382E" stroke-width="1.66667"/>
      </svg>
    </div>
  `;
  document.body.appendChild(cursor);

  let isOverSlider = false;
  let currentSlider = null;
  let currentDirection = null;
  let lastMouseMoveTime = Date.now();
  let isSliderInView = false;

  const updateCursorPosition = (e) => {
    if (!isOverSlider) return;

    cursor.style.left = `${e.clientX}px`;
    cursor.style.top = `${e.clientY}px`;
    lastMouseMoveTime = Date.now();
  };

  const checkCursorVisibility = () => {
    if (!currentSlider || !isOverSlider) return;

    const timeSinceLastMouseMove = Date.now() - lastMouseMoveTime;
    const mouseNotMoved = timeSinceLastMouseMove > 100;

    if (!isSliderInView && mouseNotMoved && cursor.classList.contains('custom-cursor--visible')) {
      cursor.classList.remove('custom-cursor--visible');
      document.body.style.cursor = '';
      currentSlider.style.cursor = '';
    }
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  const sliderObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === currentSlider) {
        isSliderInView = entry.isIntersecting;

        if (!isSliderInView) {
          setTimeout(checkCursorVisibility, 100);
        }
      }
    });
  }, observerOptions);

  const updateCursorDirection = (e, slider) => {
    if (!isOverSlider) return;

    const sliderRect = slider.getBoundingClientRect();
    const sliderCenterX = sliderRect.left + sliderRect.width / 2;
    const mouseX = e.clientX;

    const leftArrow = cursor.querySelector('.cursor-arrow--left');
    const rightArrow = cursor.querySelector('.cursor-arrow--right');

    if (mouseX < sliderCenterX) {
      leftArrow.style.opacity = '1';
      rightArrow.style.opacity = '0';
      cursor.classList.add('cursor--left');
      cursor.classList.remove('cursor--right');
      currentDirection = 'left';
    } else {
      leftArrow.style.opacity = '0';
      rightArrow.style.opacity = '1';
      cursor.classList.add('cursor--right');
      cursor.classList.remove('cursor--left');
      currentDirection = 'right';
    }
  };

  const handleSliderClick = () => {
    if (!isOverSlider || !currentSlider || !currentDirection) return;

    const swiperInstance = currentSlider.swiper;

    if (swiperInstance && cursor.classList.contains('custom-cursor--visible')) {
      if (currentDirection === 'left') {
        swiperInstance.slidePrev();
      } else {
        swiperInstance.slideNext();
      }
      cursor.classList.add('custom-cursor--clicked');
      setTimeout(() => {
        cursor.classList.remove('custom-cursor--clicked');
      }, 200);
    }
  };

  sliders.forEach((slider) => {
    sliderObserver.observe(slider);

    slider.querySelector('.swiper-wrapper').addEventListener('mouseenter', (e) => {
      isOverSlider = true;
      currentSlider = slider;
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
      cursor.classList.add('custom-cursor--visible');
      document.body.style.cursor = 'none';
      slider.style.cursor = 'none';
      lastMouseMoveTime = Date.now();
      updateCursorDirection(e, slider);
    });

    slider.querySelector('.swiper-wrapper').addEventListener('mouseleave', () => {
      isOverSlider = false;
      currentSlider = null;
      currentDirection = null;
      cursor.classList.remove('custom-cursor--visible');
      document.body.style.cursor = '';
      slider.style.cursor = '';
    });

    slider.querySelector('.swiper-wrapper').addEventListener('mousemove', (e) => {
      updateCursorPosition(e);
      updateCursorDirection(e, slider);
    });

    slider.querySelector('.swiper-wrapper').addEventListener('click', handleSliderClick);
  });

  document.addEventListener('mousemove', updateCursorPosition);
};

export default {
  init,
};
